"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtPaste = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtPaste = function SvgBtPaste(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.7028 8.79834H9.2648C8.56686 8.79834 8 9.3652 8 10.0631V20.7352C8 21.4332 8.56686 22 9.2648 22H16.7028C17.4008 22 17.9676 21.4332 17.9676 20.7352V10.0631C17.9644 9.3652 17.3975 8.79834 16.7028 8.79834ZM17.0797 20.732C17.0797 20.9417 16.9093 21.1121 16.6996 21.1121H9.26152C9.05181 21.1121 8.88143 20.9417 8.88143 20.732V10.0631C8.88143 9.85343 9.05181 9.68304 9.26152 9.68304H16.6996C16.9093 9.68304 17.0797 9.85343 17.0797 10.0631V20.732Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.5472 6H12.1092C11.4112 6 10.8444 6.56686 10.8444 7.2648C10.8444 7.51055 11.041 7.70715 11.2867 7.70715C11.5325 7.70715 11.7291 7.51055 11.7291 7.2648C11.7291 7.05509 11.8994 6.8847 12.1092 6.8847H19.5472C19.7569 6.8847 19.9273 7.05509 19.9273 7.2648V17.9369C19.9273 18.1466 19.7569 18.317 19.5472 18.317C19.3015 18.317 19.1049 18.5136 19.1049 18.7594C19.1049 19.0051 19.3015 19.2017 19.5472 19.2017C20.2451 19.2017 20.812 18.6349 20.812 17.9369V7.2648C20.812 6.56686 20.2451 6 19.5472 6Z",
    fill: "currentColor"
  }));
};

exports.SvgBtPaste = SvgBtPaste;